import React, { useEffect, useState } from 'react';
import { isRequestCancelled, requestErrorDetails } from '../../hooks/requestError.mjs';

// Legacy async handlers must not fail silently. Keep the current form mounted;
// the originating action is unknown, so recovery never resends its request.
export default function AsyncFailureNotice() {
  const [message, setMessage] = useState('');
  useEffect(() => {
    const failed = event => {
      if (isRequestCancelled(event.reason)) { event.preventDefault(); return; }
      const details = requestErrorDetails(event.reason, { fallback: 'An unexpected error occurred. Check the current page and any saved action status before trying the action again.' });
      event.preventDefault();
      setMessage(details.message);
      if (process.env.NODE_ENV === 'development') console.error('An application request failed.', details.kind, details.status);
    };
    window.addEventListener('unhandledrejection', failed);
    return () => window.removeEventListener('unhandledrejection', failed);
  }, []);
  return message ? <aside className="async-failure-notice" role="alert"><p>{message}</p><button type="button" aria-label="Dismiss error message" onClick={() => setMessage('')}>Dismiss</button></aside> : null;
}
